import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('user');
const GET_USER = define('GET_USER', true);
const GET_LOGS = define('GET_LOGS', true);
const UPDATE_USER = define('UPDATE_USER', true);
const UPDATE_USER_DEDUCTION_RATE = define('UPDATE_USER_DEDUCTION_RATE', true);
const UPDATE_USER_TRAVEL_AGENCY_COMMISSION = define('UPDATE_USER_TRAVEL_AGENCY_COMMISSION', true);
const UPDATE_FRUIT_MARKET_USER = define('UPDATE_FRUIT_MARKET_USER', true);
const VERIFY_USER = define('VERIFY_USER', true);
const REVERIFY_USER = define('REVERIFY_USER', true);
const BAN_MESSAGE = define('BAN_MESSAGE', true);
const SUSPEND_USER = define('SUSPEND_USER', true);
const SEND_SMS = define('SEND_SMS', true);
const SEND_NOTI = define('SEND_NOTI', true);
const SEND_WEB_NOTI = define('SEND_WEB_NOTI', true);
const GENERATE_ACCESS_TOKEN = define('GENERATE_ACCESS_TOKEN', true);
const GET_SESSION_DATA = define('GET_SESSION_DATA', true);
const GET_LOG_DETAIL = define('GET_LOG_DETAIL', true);
const ADD_PARTNER_CREDIT = define('ADD_PARTNER_CREDIT', true);
const UPDATE_COMMISSION_FACTOR = define('UPDATE_COMMISSION_FACTOR', true);
const CONVERT_ROLE = define('CONVERT_ROLE', true);
const GET_USER_TRIP_SWAPS = define('GET_USER_TRIP_SWAPS', true);
const ADD_USER_TO_TRIP_SWAPS = define('ADD_USER_TO_TRIP_SWAPS', true);
const REMOVE_USER_TO_TRIP_SWAPS = define('REMOVE_USER_TO_TRIP_SWAPS', true);
const UPDATE_TRIP_SWAPS = define('UPDATE_TRIP_SWAPS', true);

const initialState = {
  isLoading: true,
  user: {},
  isLoadingLog: true,
  logs: [],
  logCount: 0,
  sessionData: {},
  isLoadingSessionData: true,
  animalHash: '',
  logDetail: {},
  isLoadingLogDetail: false,
  submitting: false,
};

export default (state = initialState, action) => {
  let user;
  switch (action.type) {
    case GET_USER.PENDING:
      return {
        ...state,
        isLoading: true
      };
    case GET_USER.RESOLVED:
      user = action.data;
      if (!user.user.verification) user.user.verification = {};
      return {
        ...state,
        user,
        isLoading: false
      };
    case GET_LOGS.PENDING:
      return {
        ...state,
        isLoadingLog: true
      };
    case GET_LOGS.RESOLVED:
      return {
        ...state,
        logs: [...state.logs, ...action.data.logMessages],
        isLoadingLog: false,
        logCount: action.data.count,
        animalHash: action.data.animalHash
      };
    case GET_SESSION_DATA.PENDING:
      return {
        ...state,
        isLoadingSessionData: true
      };
    case GET_SESSION_DATA.RESOLVED:
      return {
        ...state,
        sessionData: action.data,
        isLoadingSessionData: false,
      };
    case GET_LOG_DETAIL.PENDING:
      return {
        ...state,
        isLoadingLogDetail: true
      };
    case GET_LOG_DETAIL.RESOLVED:
      return {
        ...state,
        logDetail: action.data,
        isLoadingLogDetail: false,
      };
    case UPDATE_COMMISSION_FACTOR.PENDING:
    case UPDATE_COMMISSION_FACTOR.REJECTED:
      return {
        ...state,
        submitting: true
      };
    case UPDATE_COMMISSION_FACTOR.RESOLVED:
      return {
        ...state,
        submitting: false
      };
    default: return state;
  }
};

export const actions = {
  getUser: id => ({
    type: GET_USER,
    promise: api.get(`/users/${id}`),
    error: 'Unable to load user data'
  }),
  getUserLogs: (id, skip = 0, limit = 20) => ({
    type: GET_LOGS,
    promise: api.get(`/users/${id}/logs?skip=${skip}&limit=${limit}`),
    error: 'Unable to load user logs'
  }),
  updateUser: (id, data) => ({
    type: UPDATE_USER,
    promise: api.post(`/users/${id}`, data),
    success: 'User data has been updated',
    error: 'Unable to update user data'
  }),
  convertRole: (id, role) => ({
    type: CONVERT_ROLE,
    promise: api.post(`/users/${id}/convert-role`, { role }),
    success: 'User role has been converted',
    error: 'Unable to convert user role',
  }),
  verifyUser: (id, type) => ({
    type: VERIFY_USER,
    promise: api.post(`/users/${id}/verify/${type}`),
    success: 'User verification item has been verified',
    error: 'Unable to verify'
  }),
  reverifyUser: (id, type) => ({
    type: REVERIFY_USER,
    promise: api.post(`/users/${id}/reverify/${type}`),
    success: 'User verification item has been reverified',
    error: 'Unable to reverify'
  }),
  banMessage: (id, isBan) => ({
    type: BAN_MESSAGE,
    promise: api.post(`/users/${id}`, { is_suspicious: isBan }),
    success: isBan ? 'User has been banned for chat' : 'User has been unbanned fot chat',
    error: isBan ? 'Unable to ban user' : 'Unable to unban user'
  }),
  suspendUser: (id, isSuspend) => ({
    type: SUSPEND_USER,
    promise: api.post(`/users/${id}`, { is_suspended: isSuspend }),
    success: isSuspend ? 'User has been suspended' : 'User has been unsuspended',
    error: isSuspend ? 'Unable to suspend user' : 'Unable to unsuspend user'
  }),
  sendSms: (mobile, text) => ({
    type: SEND_SMS,
    promise: api.post('/sms', { mobile, text }),
    success: 'SMS has been sent',
    error: 'Unable to send SMS'
  }),
  sendNoti: (message, userId, title = 'Message from TakeMeTour') => ({
    type: SEND_NOTI,
    promise: api.post('/push/send', { message, userId, title }),
    success: 'Push Notification has been sent',
    error: 'Unable to send push notification'
  }),
  sendWebNoti: (message, userId, title = 'Message from TakeMeTour', link) => ({
    type: SEND_WEB_NOTI,
    promise: api.post('/push/send/web', {
      message,
      recipient_id: userId,
      label: title,
      path: link
    }),
    success: 'Web Notification has been sent',
    error: 'Unable to send web notification'
  }),
  generateAccessToken: (id) => ({
    type: GENERATE_ACCESS_TOKEN,
    promise: api.get(`/users/${id}/generate-access-token`)
  }),
  getSessionData: (id) => ({
    type: GET_SESSION_DATA,
    promise: api.get(`/session/data/${id}`)
  }),
  getLogDetail: (id) => ({
    type: GET_LOG_DETAIL,
    promise: api.get(`/logs/id/${id}`),
  }),
  addPartnerCredit: (id, amount) => ({
    type: ADD_PARTNER_CREDIT,
    promise: api.put('/partner/credit', { partner_id: id, amount }),
    success: 'Partner credit has been updated',
    error: 'Unable to add partner credit'
  }),
  updateDeductionRate: (id, rate) => ({
    type: UPDATE_USER_DEDUCTION_RATE,
    promise: api.post(`/users/${id}`, { travel_agency_deduct_rate: rate }),
    success: 'Deduction rate updated successfully',
    error: 'Unable to update deduction rate'
  }),
  updateTravelAgencyCommission: (id, commission) => ({
    type: UPDATE_USER_TRAVEL_AGENCY_COMMISSION,
    promise: api.post(`/users/${id}`, { travel_agency_commission: commission }),
    success: 'Travel agency commission updated successfully',
    error: 'Unable to update travel agency commission'
  }),
  updateCommissionFactor: (id, factor) => ({
    type: UPDATE_COMMISSION_FACTOR,
    promise: api.put(`/users/${id}/affiliate-factor`, factor),
    success: 'Update Commission Factor success',
    enable: 'Unable to update commission factor'
  }),
  getUserTripSwaps: (userId) => ({
    type: GET_USER_TRIP_SWAPS,
    promise: api.get(`/users/${userId}/trip-swap`),
    error: 'Unable to load trip swaps',
  }),
  addUserToTripSwaps: (userId, swaps) => ({
    type: ADD_USER_TO_TRIP_SWAPS,
    promise: api.post(`/users/${userId}/add-to-swap`, { swaps }),
    success: 'This user has been added to the swap',
    error: 'Unable to add this user to the swap',
  }),
  removeUserFromTripSwaps: (userId, tripIds) => ({
    type: REMOVE_USER_TO_TRIP_SWAPS,
    promise: api.delete(`/users/${userId}/remove-from-swap`, { tripIds }),
    success: 'This user has been remove from the swap',
    error: 'Unable to remove this user to the swap',
  }),
  updateTripSwaps: (userId, swaps) => ({
    type: UPDATE_TRIP_SWAPS,
    promise: api.put(`/users/${userId}/update-swap`, { swaps }),
    success: 'The swap has been updated',
    error: 'Unable to update the swap',
  }),
  updateFruitMarketSeller: (id, data) => ({
    type: UPDATE_FRUIT_MARKET_USER,
    promise: api.put(`/users/${id}/fruit-market`, data),
    success: 'User data has been updated',
    error: 'Unable to update user data'
  }),
};



// WEBPACK FOOTER //
// ./src/ducks/user.js